class Index {
    rc;
    _parent;
    constructor(_parent) {
        this._parent = _parent;
        this.rc = _parent.rc;
    }
    path() {
        return `${this._parent.path()}/lock`;
    }
    /**
     * Locks a note providing the user with the unique write access for 5 hours.
     * HTTP Method: post
     * Endpoint: /team-messaging/v1/notes/{noteId}/lock
     * Rate Limit Group: Light
     * App Permission: TeamMessaging
     */
    async post(restRequestConfig) {
        const r = await this.rc.post(this.path(), {}, undefined, restRequestConfig);
        return r.data;
    }
}
export default Index;
